import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, MessageCircleIcon } from 'lucide-react';
import { ButtonAnchor } from './ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
import { CATALOGO_URL, VCARS_LOGO } from '../data/brand';
const links: {
  label: string;
  to: string;
  external?: boolean;
}[] = [{
  label: 'Inicio',
  to: '/'
}, {
  label: 'Catálogo',
  to: CATALOGO_URL,
  external: true
}, {
  label: 'Financiación 0KM',
  to: '/financiacion'
}, {
  label: 'Vendé tu auto',
  to: '/vender-mi-auto'
}, {
  label: 'Contacto',
  to: '/contacto'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);
  return <header className={`sticky top-0 z-50 border-b transition-colors duration-200 ease-smooth ${scrolled ? 'border-neon/30 bg-ink/90 shadow-[0_10px_30px_-24px_rgba(31,123,255,0.9)] backdrop-blur-xl' : 'border-transparent bg-ink/60 backdrop-blur-md'}`} data-id="element-187" data-mp="2rkq91ctbl4ka">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center gap-6 px-5 md:h-[72px] md:px-8" data-id="element-188" data-mp="3fa0yhy57zcj4">
        <Link to="/" className="flex items-center gap-2.5" aria-label="VCARS — Inicio" data-id="element-189" data-mp="3adk970maas4g">
          <img src={VCARS_LOGO} alt="Logo de VCARS" className="h-10 w-10 rounded-full object-cover ring-1 ring-neon/40 md:h-11 md:w-11" data-id="element-190" data-mp="35khg0tlf5kos" />
          <span className="text-lg font-black tracking-[0.18em] text-neon-soft" data-id="element-191" data-mp="1wpiejirgy6q">
            VCARS
          </span>
        </Link>

        <nav className="hidden flex-1 items-center gap-1 xl:flex" aria-label="Navegación principal" data-id="element-192" data-mp="3t9k70s1y0pvy">
          {links.map(l => l.external ? <a key={l.label} href={l.to} target="_blank" rel="noopener noreferrer" className="rounded-lg px-3 py-2 text-[13.5px] font-medium text-mist transition-colors duration-150 ease-smooth hover:text-white" data-id="element-193" data-mp="1wd5zyjqutc8j">
                {l.label}
              </a> : <NavLink key={l.label} to={l.to} end={l.to === '/'} className={({
          isActive
        }) => `rounded-lg px-3 py-2 text-[13.5px] font-medium transition-colors duration-150 ease-smooth ${isActive ? 'text-white' : 'text-mist hover:text-white'}`} data-id="element-194" data-mp="18pg2phdsqb4e">
                {l.label}
              </NavLink>)}
        </nav>

        <div className="ml-auto flex items-center gap-2 xl:ml-0" data-id="element-195" data-mp="2xzxbfoxj9mk8">
          <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="primary" size="sm" className="hidden lg:inline-flex" data-id="element-196" data-mp="mfg48nv31rfx">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-197" data-mp="w5j3v6wpm3n8" />
            Quiero comunicarme con un vendedor
          </ButtonAnchor>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="grid h-10 w-10 place-items-center rounded-xl border border-line bg-surface2/70 text-white xl:hidden" data-id="element-198" data-mp="rbod5jiosoen">
            {open ? <XIcon className="h-5 w-5" data-id="element-199" data-mp="1a4ikbra2jc8b" /> : <MenuIcon className="h-5 w-5" data-id="element-200" data-mp="1a5k5iokstf3r" />}
          </button>
        </div>
      </div>

      {open ? <div className="border-t border-line bg-ink/95 backdrop-blur-xl xl:hidden" data-id="element-201" data-mp="3gvhyyfsnoi8f">
          <nav className="mx-auto flex w-full max-w-7xl flex-col px-5 py-3 md:px-8" aria-label="Navegación móvil" data-id="element-202" data-mp="3bwnihki5v5rh">
            {links.map(l => l.external ? <a key={l.label} href={l.to} target="_blank" rel="noopener noreferrer" className="rounded-lg px-2 py-3 text-[15px] font-medium text-white/90 hover:bg-surface2" data-id="element-203" data-mp="27wgvgq60u9ju">
                  {l.label}
                </a> : <Link key={l.label} to={l.to} className="rounded-lg px-2 py-3 text-[15px] font-medium text-white/90 hover:bg-surface2" data-id="element-204" data-mp="1p70r1rr7twy5">
                  {l.label}
                </Link>)}
            <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="primary" size="md" className="mt-3 mb-2 w-full" data-id="element-205" data-mp="1y1f0hdp2ed9c">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="15gx0b0lha0c3" />
              Hablar con un vendedor
            </ButtonAnchor>
          </nav>
        </div> : null}
    </header>;
}